// fileKind — how a source's file kind looks and reads: its icon and its
// localised word (the Search page's Type column, the viewer header).

import { exhaustSwitchCase } from "@bilda/utils";
import { useLingui } from "@lingui/react/macro";
import type { IconName } from "../Icon/Icon.js";
import type { FileKind } from "./knowledgeBankModel.js";

export const fileKindIcon = (kind: FileKind): IconName => {
    switch (kind) {
        case "pdf":
        case "word":
        case "text":
            return "document";
        case "presentation":
            return "presentation";
        case "image":
            return "image";
        case "audio":
            return "audio";
        case "video":
            return "video";
        case "unknown":
            return "unknown-file";
        default:
            return exhaustSwitchCase(kind);
    }
};

export const useFileKindLabel = (): ((kind: FileKind) => string) => {
    const { t } = useLingui();
    return (kind) => {
        switch (kind) {
            case "pdf":
                return t`PDF`;
            case "word":
                return t`Word document`;
            case "presentation":
                return t`Presentation`;
            case "text":
                return t`Text`;
            case "image":
                return t`Image`;
            case "audio":
                return t`Audio`;
            case "video":
                return t`Video`;
            case "unknown":
                return t`File`;
            default:
                return exhaustSwitchCase(kind);
        }
    };
};
